export default __webpack_public_path__ + "static/media/removeFromInterviewNes.0f1baae0.svg";